/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How many of the times of a sign-up event a guest can sign up for.
 * The value 2 is kept for "the sign-up is for all times", for example a course, which isn't built yet.
 * @export
 */
export const WebApiModelsEnumerationTypesTimeChoice = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type WebApiModelsEnumerationTypesTimeChoice = typeof WebApiModelsEnumerationTypesTimeChoice[keyof typeof WebApiModelsEnumerationTypesTimeChoice];


export function WebApiModelsEnumerationTypesTimeChoiceFromJSON(json: any): WebApiModelsEnumerationTypesTimeChoice {
    return WebApiModelsEnumerationTypesTimeChoiceFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesTimeChoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesTimeChoice {
    return json as WebApiModelsEnumerationTypesTimeChoice;
}

export function WebApiModelsEnumerationTypesTimeChoiceToJSON(value?: WebApiModelsEnumerationTypesTimeChoice | null): any {
    return value as any;
}

